import { render } from "./PoliticaPrivacidadPage.vue?vue&type=template&id=20eb8594"
import script from "./PoliticaPrivacidadPage.vue?vue&type=script&lang=js"
export * from "./PoliticaPrivacidadPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__